import css from "@styled-system/css";
import { Box } from "atoms";
import styled from "styled-components";

export const DateInputBase = styled(Box)`
  margin: 0;
  width: 100%;
  display: grid;
  font-weight: 500;
  font-size: 1.6rem;
  position: relative;
  align-items: center;
  /* margin-bottom: 2.4rem; */

  ${css({
    ".calendar-icon": {
      top: "1.5rem",
      color: "neutral.700",
    },
    input: {
      // p: "1rem",
      p: "1.3rem 1.6rem !important",
      width: "100%",
      height: "4.8rem",
      outline: "none",
      fontWeight: "500",
      fontSize: "1.6rem",
      border: "1px solid",
      borderRadius: "1rem",
      borderColor: "neutral.300",
      "::placeholder": {
        color: "neutral.500",
      },
      "&:hover": {
        borderColor: "primary.300",
      },
      "&:focus": {
        borderColor: "primary.700",
      },
      "&.input-error": {
        borderColor: "red.500",
      },
      "&:disabled": {
        bg: "white",
        color: "neutral.300",
        "&:hover": {
          borderColor: "neutral.300",
        },
      },
    },
  })}
`;
